// extracted by mini-css-extract-plugin
export var text = "_58-0";